import PropTypes from 'prop-types';
import React from 'react';
import createTheme from './theme.js';
import {DARK_THEME, LIGHT_THEME} from '@apps-common/ui-theme/Themes';
import {ThemeProvider as MuiThemeProvider} from '@mui/material';

export const ThemeProvider = ({children, ...props}) => (
  <MuiThemeProvider theme={createTheme(props.dark ? DARK_THEME : LIGHT_THEME)}>
    {children}
  </MuiThemeProvider>
);

ThemeProvider.defaultProps = {
  dark: false,
};

ThemeProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  dark: PropTypes.bool,
};
